(function () {
    angular.module('shared').service('RequestRejector', ['$q', '$rootScope', 'localStorageService', function ($q, $rootScope, localStorageService) {        
        return RequestRejector = {            
            request: function (config) {
                config.headers = config.headers || {};
                var user = localStorageService.get("user");
                if (user) {
                    config.headers.Authorization = 'Token ' + user.SessionId;
                }

                config.headers.ClientId = RequestRejector.getClientId();
                return config;
            },
            responseError: function (response) {
                if (response.status === 401) {
                    $rootScope.$broadcast('unauthorized', response);
                }
                return $q.reject(response);
            },
            generateGuid: function() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            },
            getClientId: function() {
                var infor = localStorageService.get("localinfo");
                if (infor) {
                    if (!infor.clientId) {
                        infor.clientId = RequestRejector.generateGuid();
                        localStorageService.set("localinfo", infor);
                    }
                } else {
                    infor = {
                        clientId: RequestRejector.generateGuid()
                    }
                    localStorageService.set("localinfo", infor);
                }

                return infor.clientId;
            }
        };
    }]);
}());